<template>
	<CommentActivity
		class="goal-kr-comment-activity"
		:activity="activity"
		translation-namespace="common-gokr.components.GoalKRCommentActivity"
	/>
</template>

<script>
import CommentActivity from "../Activity/CommentActivity.vue";

export default {
	name: "GoalKRCommentActivity",
	components: {
		CommentActivity,
	},
	props: {
		/** { changedBy:String, changedByPicture:String, comment:String, changedAt:String } */
		activity: {
			type: Object,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
